import React from "react";
import opportunity from "../Assets/Landing/jobInfo icons/opportunity.png";
import man from "../Assets/Landing/jobInfo icons/man2.png";
import people from "../Assets/Landing/jobInfo icons/img.png";
import like from "../Assets/Landing/jobInfo icons/icon6.png";
import green from "../Assets/Landing/jobInfo icons/icon7.png";
import heart from "../Assets/Landing/jobInfo icons/icon8.png";

const Animation = () => {
  return (
    <>
      {/* Main Content Section with Border */}
      <section className="flex flex-col md:flex-row items-center justify-center bg-background mt-2  p-6  shadow-md relative">
        {/* Opportunity Image */}
        <img 
          src={opportunity} 
          alt="opportunity" 
          className="absolute top-16 left-0 h-26 w-26 md:h-32 md:w-32 m-2"
        />

        <h1 className="text-center font-bold text-3xl text-textWhite mb-2 mt-0">
          Get the job that's right for you
        </h1>
        
        {/* Left Section: Text Content */}
        <section className="md:w-1/2 p-6 border-r-4 border-gray-200">
          {[ 
            {
              title: "Discover New Opportunities",
              text: "Structured digital interviews increase the predictive validity of your hires by 65%.",
            },
            {
              title: "Get Invited To Apply To Jobs",
              text: "Maverick pitches your profile to employers for jobs you'll love—so you stand out, and these companies can reach out to you directly.",
            },
            {
              title: "Save Time With 1-Click Apply",
              text: "No more filling out lengthy applications! Once Maverick has your key info, you can apply to most jobs with one click.",
            }
          ].map((item, index) => (
            <div key={index} className="mb-8">
              <div className="flex items-start group">
                {/* Vertical Line Animation */}
                <div className="h-16 w-1.5 bg-gray-200 rounded-full mr-4 group-hover:bg-green-600 transition duration-300 font-josefin"></div>
                <div>
                  <h2 className="font-bold text-xl text-background2 mb-2">{item.title}</h2>
                  <p className="text-background2 font-josefin">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </section>
        
        {/* Right Section: Image and Icons */}
        <section className="md:w-1/2 relative p-6">
          <div className="relative w-full flex justify-center">
            {/* Main Image */}
            <img
              src={man}
              alt="manPhoto"
              className="mr-32 h-[300px] w-[300px] md:h-[400px] md:w-[400px] object-cover"
            />

            {/* Candidates Info */}
            <div className="flex bg-white items-center absolute mt-12 right-8 border rounded-full px-4 py-2 shadow-md">
              <img src={people} alt="people" className="h-10 p-1" />
              <p className="text-gray-600 p-1">
                <b>4800+</b> <br /> Candidates Happy
              </p>
            </div>
          </div>

          {/* Icons with Animations */}
          <img
            src={like}
            alt="like"
            className="absolute top-1/4 right-[85%] h-20 w-20 md:h-20 md:w-20"
          />
          <img
            src={green}
            alt="green"
            className="absolute top-[40%] left-[65%] h-16 w-16 md:h-20 md:w-20 animate-upDown"
          />
          <img
            src={heart}
            alt="heart"
            className="absolute bottom-[20%] left-[30%] h-16 w-16 md:h-20 md:w-20 animate-leftRight"
          />
        </section>
      </section>
    </>
  );
};

export default Animation;
